<template>
<div id="recursos">

  <section id = "intro">
    <div class = "container">
      <h1> Ayuda y Recursos para empezar a programar </h1>
      <p>Internet está lleno de recursos para aprender . Processing, P5.js o Three.js no van a ser menos.
      Aquí os hablamos de esta plataforma y enlazamos algunos cursos y textos, priorizando el castellano
      </p>
    </div>
  </section>

  <section id = "index">
    <div class = "container">
      <h2>Indice</h2>
        <ul>
          <li> <a class = "btn-icon" href = "#"  v-scroll-to = "'#programalaplaza'"> Programalaplaza </a> </li>
          <li> <a class = "btn-icon" href = "#"  v-scroll-to = "'#processingjs'"> Processing.js </a></li>
          <li> <a class = "btn-icon" href = "#"  v-scroll-to = "'#p5js'"> P5.js </a></li>
          <li> <a class = "btn-icon" href = "#"  v-scroll-to = "'#threejs'"> three.js </a></li>
        </ul>
    </div>
  </section>

  <section id = "programalaplaza">
    <div class = "container">
      <h2>Programalaplaza</h2>
      <p>
        Programalaplaza es un editor online para la fachada de medialab-prado que lanzamos en 2015. <br/>
        El motivo de lanzar esta plataforma es el de facilitar a todo el mundo crear contenidos para la fachada de Medialab-prado.
        <br/> Esta fachada es un gran canvas digital de baja resolución: ¡192x157 pixels! Más o menos como una "Gameboy" de 15 metros.
        Aquí puedes leer más sobre los <a href="https://www.medialab-prado.es/noticias/fachada-digital-informacion-tecnica-0" target="_blank"> datos técnicos de la fachada </a>
      </p>

      <p>Estos son los proyectos presentados otros años que puedes revisar en la galería:</p>
      <div class = "flex-video">
        <iframe src="https://player.vimeo.com/video/100365334" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>
      <div class = "flex-video">
        <iframe src="https://player.vimeo.com/video/67309091" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>
      <p>
      Originalmente sólo soportaba la versión web de Processing llamada <strong> Processing.js</strong> En esta nueva versión incorporamos nuevos lenguajes: <strong>P5.js y Three.js</strong>
      A continuación puedes leer más sobre  ellos
      </p>
    </div>
  </section>

  <section id = "processing">
    <div class = "container">
      <h2>Processing y Processing.js</h2>
      <p>
        <a href="https://es.wikipedia.org/wiki/Processing" target="_blank">Processing </a> es un lenguaje de programación que creado por Ben Fry y Casey Reas en el MIT con la intención de que artistas y diseñadores pudieran desarrollar sus creaciones de forma fácil y sin tener que pelear demasiado con configuraciones de software, descargas, IDEs.
        Solo es necesario <a href="https://processing.org/download/" target="_blank"> descargar el su entorno </a> y empezar a programar.
      </p>
      <p>
        Si quieres aprender sobre lo que significa crear imágenes utilizando código, más allá de los fundamentos técnicos. Echa un vistazo a este documental sobre processing:
        <a href="https://vimeo.com/60735314"> Hello World! Processing </a>
      </p>
    </div>
  </section>

  <section id = "processing">
    <div class = "container">
      <h2>Processing.js</h2>
        <p>
          En 2014 surgió <a href ="http://processingjs.org/download/" target="_blank">Processing.js</a>
          Es una librería de javascript que es capaz de interpretar prácticamente el mismo lenguaje que processing, pero dentro de un navegador web.
        </p>
        <p>
          * Aunque la librería funciona internamente con javascript, nosotros escribimos código en “processing” no en javascript.
        </p>
        <p>
          ** Todo el código de processing no funciona igual en processing.js. Además Si usamos librerías externas no va a funcionar.
        </p>

      <div class = "recursos">
        <h3>Recursos</h3>
        <p>
          Para los que prefiráis videos en castellano.
          <a href="https://www.youtube.com/playlist?list=PLtyMmy0eKyqFsLPesmz7y4EznkZFJrGuu" target="_blank"> Este tutorial es un poco lento, pero tiene bastantes temas</a>
          <br/>Pero si el inglés no es un problema o no os importa leer subtítulos, los <a href="https://www.youtube.com/watch?v=2VLaIr5Ckbs&list=PLRqwX-V7Uu6ZYJC7L-r6rX6utt6wwJCyi"> vídeos de Daniel Shiffman en su canal de youtube “The Coding Train” </a> son insuperables.
        </p>
        <div class = "flex-video">
          <iframe src="https://www.youtube.com/embed/2VLaIr5Ckbs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section>

  <section id = "p5js">
    <div class = "container">
      <h2>P5.js</h2>
      <p>
        Processing.js ya no está actualizada, pero existe una versión web de processing llamada “P5.js” y apoyada desde la “fundación processing”.
        A diferencia del anterior, aquí SI escribimos código JAVASCRIPT pero tenemos funciones muy similares a las de processing.
        <a href="https://github.com/processing/p5.js/wiki/Processing-transition" target="_blank"> Aquí puedes aprender más sobre las diferencias.</a>
      </p>

      <div class = "recursos">
        <h3>Recursos</h3>
        <p>
          P5.js es la traducción a javascript de processing.

          <br/> En la propia web de P5.js tienen mucho   <a href="https://p5js.org/es/learn/" target="_blank">  contenido en castellano </a>
           e incluso un libro que puedes <a href="https://processingfoundation.press/product/introduccion-a-p5-js/" target="_blank"> descargar pagando el precio que quieras</a>
          <br/><strong>En inglés</strong> (con subtitulos en castellano) de nuevo tenemos los <a href="https://www.youtube.com/watch?v=yPWkPOfnGsw&list=PLRqwX-V7Uu6Zy51Q-x9tMWIv9cueOFTFA" target="_blank"> tutoriales de Daniel Shiffman.</a> Si él te aburre, entonces si,  dedicate a otra cosa.
        </p>
      </div>
    </div>
  </section>

  <section id = "threejs">
    <div class = "container">
      <h2>Three.js</h2>
      <p>
        <a href="https://threejs.org/" target="_blank">  Es una librería para javascript orientada a la programación 3D</a>.
        La curva de aprendizaje es mas alta que con processing porque requiere por un lado conocer javascript con un cierto nivel y después aprender los fundamentos de la programación 3D.
        Lo incluimos entre las opciones de programalaplaza por ser una de las opciones más populares para programar 3D en la web.
      </p>

      <div class = "recursos">
        <h3>Recursos</h3>
        <p>En castellano no hemos encontrado un recurso "definitivo" para aprender threejs de 0 a 100.
          Echa un vistazo a este pequeño tutorial donde puedes encontrar algunos <a href="https://webdesign.tutsplus.com/es/tutorials/a-noobs-guide-to-threejs--cms-28639 " target="_blank"> fundamentos básicos </a>.
        </p>
        <p>La API de threejs ha cambiado bastante en los últimos años así que algunas instrucciones que encuentres en páginas antiguas pueden ser un poco diferentes. </p>

        <p>
          <strong>En inglés</strong> la propia página de threejs cuenta <a href="https://threejs.org/docs/index.html#manual/en/introduction/Creating-a-scene" target="_blank"> con varios tutoriales</a> y multitud de ejemplos. Una vez controles los fundamentos de cámara, renderers, etc, es buena idea aprender a partir de estos ejemplos.
        </p>
      </div>

    </div>
  </section>

</div>
</template>

<script>
import Logo from '../UI/Logo'

export default {
  name: 'Recursos',
  components: {
    Logo
  },
  data: () => ({
  }),
  watch: {
  },
  computed: {
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

#recursos {
  padding-top: 50px;
  font-size: 1.2em;

  .container {
    padding: 30px 20px;
  }
}

h1, h2, h3 {
  font-family: 'Share Tech';
}

h1 {
  max-width: 351px;
  line-height: 1.3em;
  text-decoration-line: underline;
  text-decoration-color: @accentColor;
  font-size: 1.5rem;
  margin-bottom: 20px;
}

h2 {
  color: @accentColor;
  font-size: 1.75em;
  font-weight: 600;
}

p {
  margin-bottom: 0.5em;
  line-height: 1.6em;
}

ul {
  border-left: 3px solid #2fe67c;
  padding-left: 10px;
}

iframe {
  width: 100%;
  height: 500px;
  margin: 20px 0;
}

.recursos {
  background: #f0f0f0;
  padding: 20px 20px;
  border-radius: 2px;
  margin-top: 30px;
}

.flex-video {
  position: relative;
  padding-top: 25px;
  padding-bottom: 67.5%;
  height: 0;
  margin-bottom: 16px;
  overflow: hidden;
}

.flex-video.widescreen { padding-bottom: 57.25%; }
.flex-video.vimeo { padding-top: 0; }

.flex-video iframe,
.flex-video object,
.flex-video embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media only screen and (max-device-width: 800px), only screen and (device-width: 1024px) and (device-height: 600px), only screen and (width: 1280px) and (orientation: landscape), only screen and (device-width: 800px), only screen and (max-width: 767px) {
  .flex-video { padding-top: 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Recursos.vue